import * as React from 'react';
import * as _ from 'lodash-es';
import queryString from 'query-string';
import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import CircularProgress from '@mui/material/CircularProgress';
import { ReduxState } from '../../reducers/types';
import { getLogin } from '../../actions/User/Login';
import {  } from 'react-router-dom';

const styles = require('./styles.pcss');

type Props = any;

type State = {
  email: string;
  password: string;
  errorEmail: boolean;
  errorPassword: boolean;
  waitingResponse: boolean;
  showPassword: boolean;
  loading: boolean;
};

class Auth extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errorEmail: false,
      errorPassword: false,
      waitingResponse: false,
      showPassword: false,
      loading: false,
    };

    if (_.get(this.props.userLogin, 'isLoggedIn', false) === true) {
      this.navigate(`/lookup/`);
    }
  }

  componentDidMount() {
    const queryStringObject = queryString.parse(location.search);

    if (queryStringObject.accessToken) {
      localStorage.setItem(
        'login_data',
        JSON.stringify({ token: queryStringObject.accessToken }),
      );
    }

    this.props.getLogin();
  }
  navigate = (path: string) => {
    this.props.navigate(path);
  };

  componentWillReceiveProps(nextProps: any) {
    if (_.get(nextProps.userLogin, 'isLoggedIn', false) === true) {
      this.navigate(`/lookup/`);
      return;
    }

    if (_.get(nextProps.userLogin, 'redirectNoAccess', false) === true) {
      this.navigate(`/`);
      return;
    }
  }

  render() {
    return (
      <div className={styles.pageAuth}>
        <CircularProgress
          size={24}
          style={{
            position: 'absolute',
            left: '50%',
            marginTop: 28,
            marginLeft: -12,
          }}
        />
      </div>
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    userLogin: state.userLogin,
  };
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getLogin,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connectWithRouter(mapStateToProps, mapDispatchToProps)(Auth);
